interface PopoverDescriptor
{
	value: string;
	body: string;
	direction: string;
}

class Popover
{
	protected element: HTMLElement;

	constructor(descriptor: PopoverDescriptor)
	{

		this.element = document.createElement( 'button' );

		$( this.element ).addClass( 'btn btn-default' );

		$( this.element ).attr( 'type', 'button');
		$( this.element ).attr( 'data-container', 'body');
		$( this.element ).attr( 'data-toggle', 'popover');
		$( this.element ).html( descriptor.value);

	 if ( descriptor.body )
		{
			$( this.element ).attr( 'data-content', descriptor.body);
		}
		else
		{
			 // XXX nur für die Entwicklung
			 alert('Error: Popover braucht einen body !');
		}

		$( this.element ).attr( 'data-placement', descriptor.direction );
	}

	public getElement() : HTMLElement
	{
		$( this.element ).popover();

		return this.element;
	}

}
